import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';

export const FieldEngineerDashboardStatStyled = styled(Box).attrs({
  px: { sm: '600' },
  py: { sm: '500' },
})`
  ${({ theme }) => css`
    & > :not(:last-child) {
      margin-right: ${theme.spacings[500]};
    }
  `}

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    & > :not(:last-child) {
      margin-right: ${({ theme }) => theme.spacings[450]};
    }
  }
`;

export const FieldEngineerLeftSectionStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  ${({ theme }) => css`
    position: relative;
    background-color: ${theme.colors.white};
    border-radius: ${theme.radii[400]};
    width: 100%;
    @media only screen and (max-width: ${theme.breakpoints.widescreen}) {
      margin-right: ${theme.spacings[500]};
    }
    @media only screen and (max-width: ${theme.breakpoints.desktop}) {
      margin-right: ${theme.spacings[400]};
    }
  `};
`;
